import ExternalAuthOptions from './ExternalAuthOptions'

export default ExternalAuthOptions
